export default "__VITE_ASSET__DQy3lUY7__"